import{a as c}from"./chunk-JW3WMNUL.js";import{a as n}from"./chunk-Y6WUNNTP.js";import{m as a}from"./chunk-HBP5N4FR.js";a();function i(r){return c(r),n(r),null}export{i as a};
//# sourceMappingURL=chunk-C5IPMGUP.js.map
